enum MintOption {
  MINT = "Mint",
  LAZY_MINT = "Lazy Mint",
}

export default MintOption;
